import competitionReducer from './competition';
import actions from '../actions';
import { activities } from '../constants';

import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';

const activityReducer = handleActions(
  [
    [actions.countdown, activities.COUNTDOWN],
    [actions.introduction, activities.INTRODUCTION],
    [actions.break, activities.BREAK],
    [actions.competition, activities.COMPETITION],
    [actions.victoryCeremony, activities.VICTORY_CEREMONY],
  ].reduce(
    (hash, [actions, activity]) => ({
      ...hash,
      [actions.begin]: () => activity,
      [actions.end]: state => (state === activity ? null : state),
    }),
    {},
  ),
  null,
);

const reducer = combineReducers({
  activity: activityReducer,
  competition: competitionReducer,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/venue/reducers/index.js